import { addHours, differenceInDays, differenceInMinutes, format, lastDayOfMonth, parseISO, } from 'date-fns';
export const isTimeDifference15mins = (endDate, startDate) => {
    try {
        return differenceInMinutes(endDate, startDate) === 15;
    }
    catch {
        return false;
    }
};
export const toUtcDayISO = (value) => {
    const d = value instanceof Date ? value : new Date(value);
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())).toISOString();
};
export const MONTH_INITIALS = [
    'J',
    'F',
    'M',
    'A',
    'M',
    'J',
    'J',
    'A',
    'S',
    'O',
    'N',
    'D',
];
export function getDatesToLabelInQuarter(first, last) {
    const year = first.getFullYear();
    const firstMonth = first.getMonth();
    const lastMonth = last.getMonth();
    const dates = [];
    for (let month = firstMonth; month <= lastMonth; month++) {
        const date = new Date(year, month, 1);
        dates.push(date);
    }
    dates.push(last);
    return dates;
}
export function getDatesToLabelInArbitraryRange(first, last) {
    const daysDiff = differenceInDays(last, first);
    let step;
    if (daysDiff === 4) {
        // When there are 5 days, display 3 labels instead of 4
        step = 2;
    }
    else {
        step = Math.max(daysDiff / 3, 1);
    }
    const dates = [];
    for (let date = first; date <= last; date = addHours(date, step * 24)) {
        dates.push(date);
    }
    return dates;
}
/**
 * @param steps Must start with the first day of a year; Must contain consecutive days.
 *        May end before or on the last day of the same year.
 * @returns The transformed steps that contain the cumulative spending at the end of each month.
 *          Length may be below 12 when the input dates end before the last month.
 */
export function aggregateSpendingBreakdownByMonth(steps) {
    const lastDate = parseISO(steps[steps.length - 1].date);
    const year = lastDate.getFullYear();
    const lastMonth = lastDate.getMonth();
    const endOfMonths = [];
    let i = 0;
    for (let month = 0; month < lastMonth; month++) {
        const date = format(lastDayOfMonth(new Date(year, month, 1)), 'yyyy-MM-dd');
        while (i < steps.length && steps[i].date < date) {
            i += 1;
        }
        if (i < steps.length && steps[i].date === date) {
            // the more likely case
            endOfMonths.push(steps[i]);
        }
        else {
            // the input is erroneous
            endOfMonths.push(steps[i - 1]);
        }
    }
    // Push the value of the last month.
    endOfMonths.push(steps[steps.length - 1]);
    return endOfMonths;
}
